module.exports = __webpack_public_path__ + "static/media/test_auv.830ff29b.jpg";